/**
 * Utility per contenuti HTML prodotti dall'editor WYSIWYG (RichTextEditor).
 *
 * Regex-based (nessuna dipendenza dal DOM): adeguate a estrarre testo per
 * anteprime, titoli troncati, ricerca client-side e validazione "campo non
 * vuoto". NON sostituiscono la sanitizzazione (DOMPurify) al render: servono
 * solo a derivare testo semplice, non a rendere sicuro l'HTML.
 */

/** Testo semplice da HTML: rimuove i tag, normalizza i &nbsp; e trim. */
export function htmlToPlainText(html: string): string {
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/\xa0/g, ' ')
    .trim();
}

/**
 * Come htmlToPlainText, ma PRESERVA gli "a capo" strutturali dell'HTML: `<br>` e
 * i tag block (p, div, li, heading, tr, blockquote) diventano `\n`.
 * Serve per le anteprime dove la struttura su piu' righe e' significativa (es.
 * saluto + virgola + a capo + corpo email). I newline multipli vengono collassati
 * a uno solo (niente righe vuote), cosi' l'anteprima a 2 righe non le "spreca".
 *
 * Lo stacco lo fa sia il tag di APERTURA sia quello di chiusura. Guardare solo
 * la chiusura non basta con l'HTML che produce un contenteditable, dove il
 * primo paragrafo e' testo nudo e i successivi sono blocchi:
 * `Testo.<div>Formattato</div>` diventava `Testo.Formattato`, con le due frasi
 * incollate.
 */
export function htmlToPlainTextPreserveBreaks(html: string): string {
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/?(p|div|li|h[1-6]|tr|blockquote)(\s[^>]*)?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/\xa0/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{2,}/g, '\n')
    .trim();
}

/** true se l'HTML contiene testo reale (ignora tag e spazi). */
export function htmlHasText(html: string): boolean {
  return htmlToPlainText(html).length > 0;
}
